export default [
   
   
      {id:'ITA',label:'ITALIA'},
      {id:'AFG',label:'AFGANISTAN'},
      {id:'ALB',label:'ALBANIA'},
      {id:'DZA',label:'ALGERIA'},
      {id:'AND',label:'ANDORRA'},
      {id:'AGO',label:'ANGOLA'},
      {id:'AIA',label:'ANGUILLA'},
      {id:'ATA',label:'ANTARTIDE'},
      {id:'ATG',label:'ANTIGUA E BARBUDA'},
      {id:'ANT',label:'ANTILLE OLANDESI'},
      {id:'SAU',label:'ARABIA SAUDITA'},
      {id:'ARG',label:'ARGENTINA'},
      {id:'ARM',label:'ARMENIA'},
      {id:'ABW',label:'ARUBA'},
      {id:'AUS',label:'AUSTRALIA'},
      {id:'AUT',label:'AUSTRIA'},
      {id:'AZE',label:'AZERBAIJAN'},
      {id:'BHS',label:'BAHAMAS'},
      {id:'BHR',label:'BAHRAIN'},
      {id:'BGD',label:'BANGLADESH'},
      {id:'BRB',label:'BARBADOS'},
      {id:'BEL',label:'BELGIO'},
      {id:'BLZ',label:'BELIZE'},
      {id:'BEN',label:'BENIN'},
      {id:'BMU',label:'BERMUDA'},
      {id:'BTN',label:'BHUTAN'},
      {id:'BLR',label:'BIELORUSSIA'},
      {id:'BOL',label:'BOLIVIA'},
      {id:'BIH',label:'BOSNIA - ERZEGOVINA'},
      {id:'BWA',label:'BOTSWANA'},
      {id:'BVT',label:'BOUVET ISLAND'},
      {id:'BRA',label:'BRASILE'},
      {id:'BRN',label:'BRUNEI'},
      {id:'BGR',label:'BULGARIA'},
      {id:'BFA',label:'BURKINA FASO'},
      {id:'BDI',label:'BURUNDI'},
      {id:'KHM',label:'CAMBOGIA'},
      {id:'CMR',label:'CAMERUN'},
      {id:'CAN',label:'CANADA'},
      {id:'CPV',label:'CAPO VERDE'},
      {id:'TCD',label:'CIAD'},
      {id:'CHL',label:'CILE'},
      {id:'CHN',label:'CINA'},
      {id:'CYP',label:'CIPRO'},
      {id:'COL',label:'COLOMBIA'},
      {id:'COM',label:'COMORE'},
      {id:'COG',label:'CONGO'},
      {id:'PRK',label:'COREA DEL NORD'},
      {id:'KOR',label:'COREA DEL SUD'},
      {id:'CIV',label:'COSTA D\'AVORIO'},
      {id:'CRI',label:'COSTA RICA'},
      {id:'HRV',label:'CROAZIA'},
      {id:'CUB',label:'CUBA'},
      {id:'DNK',label:'DANIMARCA'},
      {id:'DMA',label:'DOMINICA'},
      {id:'ECU',label:'ECUADOR'},
      {id:'EGY',label:'EGITTO'},
      {id:'SLV',label:'EL SALVADOR'},
      {id:'ARE',label:'EMIRATI ARABI UNITI'},
      {id:'ERI',label:'ERITREA'},
      {id:'EST',label:'ESTONIA'},
      {id:'ETH',label:'ETIOPIA'},
      {id:'FJI',label:'FIGI'},
      {id:'PHL',label:'FILIPPINE'},
      {id:'FIN',label:'FINLANDIA'},
      {id:'FRA',label:'FRANCIA'},
      {id:'ATF',label:'FRENCH SOUTHERN TERRITORIES'},
      {id:'GAB',label:'GABON'},
      {id:'GMB',label:'GAMBIA'},
      {id:'GEO',label:'GEORGIA'},
      {id:'SGS',label:'GEORGIA DEL SUD E ISOLE SANDWICH MERIDIONALI'},
      {id:'DEU',label:'GERMANIA'},
      {id:'GHA',label:'GHANA'},
      {id:'JAM',label:'GIAMAICA'},
      {id:'JPN',label:'GIAPPONE'},
      {id:'GIB',label:'GIBILTERRA'},
      {id:'DJI',label:'GIBUTI'},
      {id:'JOR',label:'GIORDANIA'},
      {id:'GRC',label:'GRECIA'},
      {id:'GRD',label:'GRENADA (WEST INDIES)'},
      {id:'GRL',label:'GROENLANDIA'},
      {id:'GLP',label:'GUADALUPA(ST.BARTH. - NORTH.ST.MAR.)'},
      {id:'GUM',label:'GUAM'},
      {id:'GTM',label:'GUATEMALA'},
      {id:'GGY',label:'GUERNSEY'},
      {id:'GUF',label:'GUIANA FRANCESE'},
      {id:'GIN',label:'GUINEA'},
      {id:'GNB',label:'GUINEA - BISSAU'},
      {id:'GNQ',label:'GUINEA EQUATORIALE'},
      {id:'GUY',label:'GUYANA'},
      {id:'HTI',label:'HAITI'},
      {id:'HMD',label:'HEARD AND MC DONALD ISLANDS'},
      {id:'HND',label:'HONDURAS'},
      {id:'HKG',label:'HONG KONG'},
      {id:'IND',label:'INDIA'},
      {id:'IDN',label:'INDONESIA'},
      {id:'IRN',label:'IRAN'},
      {id:'IRQ',label:'IRAQ'},
      {id:'IRL',label:'IRLANDA'},
      {id:'ISL',label:'ISLANDA'},
      {id:'CXR',label:'ISLANDS CHRISTMAS'},
      {id:'IMN',label:'ISOLA DI MAN'},
      {id:'NFK',label:'ISOLA NORFOLK'},
      {id:'ALA',label:'ISOLE ALAND'},
      {id:'CYM',label:'ISOLE CAYMAN'},
      {id:'CCK',label:'ISOLE COCOS (KEELING)'},
      {id:'COK',label:'ISOLE COOK'},
      {id:'FLK',label:'ISOLE FALKLAND'},
      {id:'FRO',label:'ISOLE FAROE'},
      {id:'MNP',label:'ISOLE MARIANNE DEL NORD'},
      {id:'MHL',label:'ISOLE MARSHALL'},
      {id:'TCA',label:'ISOLE TURKS E CAICOS'},
      {id:'VGB',label:'ISOLE VERGINI (GB)'},
      {id:'VIR',label:'ISOLE VERGINI (US)'},
      {id:'ISR',label:'ISRAELE'},
      {id:'JEY',label:'JERSEY'},
      {id:'KAZ',label:'KAZAKHSTAN'},
      {id:'KEN',label:'KENYA'},
      {id:'KIR',label:'KIRIBATI'},
      {id:'XKX ',label:'KOSOVO'},
      {id:'KWT',label:'KUWAIT'},
      {id:'KGZ',label:'KYRGYZSTAN'},
      {id:'LAO',label:'LAOS'},
      {id:'LSO',label:'LESOTHO'},
      {id:'LVA',label:'LETTONIA'},
      {id:'LBN',label:'LIBANO'},
      {id:'LBR',label:'LIBERIA'},
      {id:'LBY',label:'LIBIA'},
      {id:'LIE',label:'LIECHTENSTEIN'},
      {id:'LTU',label:'LITUANIA'},
      {id:'LUX',label:'LUSSEMBURGO'},
      {id:'MAC',label:'MACAO'},
      {id:'MKD',label:'MACEDONIA'},
      {id:'MDG',label:'MADAGASCAR'},
      {id:'MWI',label:'MALAWI'},
      {id:'MDV',label:'MALDIVE'},
      {id:'MYS',label:'MALESIA'},
      {id:'MLI',label:'MALI'},
      {id:'MLT',label:'MALTA'},
      {id:'MAR',label:'MAROCCO'},
      {id:'MTQ',label:'MARTINICA'},
      {id:'MRT',label:'MAURITANIA'},
      {id:'MUS',label:'MAURITIUS'},
      {id:'MYT',label:'MAYOTTE'},
      {id:'MEX',label:'MESSICO'},
      {id:'FSM',label:'MICRONESIA'},
      {id:'MDA',label:'MOLDAVIA'},
      {id:'MCO',label:'MONACO'},
      {id:'MNG',label:'MONGOLIA'},
      {id:'MNE',label:'MONTENEGRO'},
      {id:'MSR',label:'MONTSERRAT'},
      {id:'MOZ',label:'MOZAMBICO'},
      {id:'MMR',label:'MYANMAR'},
      {id:'NAM',label:'NAMIBIA'},
      {id:'NRU',label:'NAURU'},
      {id:'NPL',label:'NEPAL'},
      {id:'NIC',label:'NICARAGUA'},
      {id:'NER',label:'NIGER'},
      {id:'NGA',label:'NIGERIA'},
      {id:'NIU',label:'NIUE'},
      {id:'NOR',label:'NORVEGIA'},
      {id:'-1 ',label:'NULL'},
      {id:'NCL',label:'NUOVA CALEDONIA'},
      {id:'NZL',label:'NUOVA ZELANDA'},
      {id:'OMN',label:'OMAN'},
      {id:'NLD',label:'PAESI BASSI'},
      {id:'PAK',label:'PAKISTAN'},
      {id:'PLW',label:'PALAU'},
      {id:'PSE',label:'PALESTINA'},
      {id:'PAN',label:'PANAMA'},
      {id:'PNG',label:'PAPUA NUOVA GUINEA'},
      {id:'PRY',label:'PARAGUAY'},
      {id:'PER',label:'PERÙ'},
      {id:'PCN',label:'PITCAIRN'},
      {id:'PYF',label:'POLINESIA FRANCESE'},
      {id:'POL',label:'POLONIA'},
      {id:'PRT',label:'PORTOGALLO'},
      {id:'PRI',label:'PUERTO RICO'},
      {id:'QAT',label:'QATAR'},
      {id:'GBR',label:'REGNO UNITO'},
      {id:'CZE',label:'REPUBBLICA CECA'},
      {id:'CAF',label:'REPUBBLICA CENTRAFRICANA'},
      {id:'COD',label:'REPUBBLICA DEMOCRATICA DEL CONGO'},
      {id:'DOM',label:'REPUBBLICA DOMINICANA'},
      {id:'REU',label:'REUNION'},
      {id:'ROU',label:'ROMANIA'},
      {id:'RWA',label:'RUANDA'},
      {id:'RUS',label:'RUSSIA'},
      {id:'ESH',label:'SAHARA OCCIDENTALE'},
      {id:'SHN',label:'SAINT HELENA'},
      {id:'KNA',label:'SAINT KITTS E NEVIS'},
      {id:'LCA',label:'SAINT LUCIA'},
      {id:'SPM',label:'SAINT PIERRE E MIQUELON'},
      {id:'VCT',label:'SAINT VINCENT E GRENADINE'},
      {id:'SLB',label:'SALOMONE'},
      {id:'WSM',label:'SAMOA'},
      {id:'ASM',label:'SAMOA AMERICANE'},
      {id:'SMR',label:'SAN MARINO'},
      {id:'STP',label:'SAO TOME E PRINCIPE'},
      {id:'SEN',label:'SENEGAL'},
      {id:'SRB',label:'SERBIA'},
      {id:'SYC',label:'SEYCHELLES'},
      {id:'SLE',label:'SIERRA LEONE'},
      {id:'SGP',label:'SINGAPORE'},
      {id:'SYR',label:'SIRIA'},
      {id:'SVK',label:'SLOVACCHIA'},
      {id:'SVN',label:'SLOVENIA'},
      {id:'SOM',label:'SOMALIA'},
      {id:'ESP',label:'SPAGNA'},
      {id:'LKA',label:'SRI LANKA'},
      {id:'USA',label:'STATI UNITI D\' AMERICA'},
      {id:'UMI',label:'STATI UNITI D\'AMERICA - ISOLE MINORI'},
      {id:'VAT',label:'STATO DEL VATICANO'},
      {id:'ZAF',label:'SUD AFRICA'},
      {id:'SDN',label:'SUDAN'},
      {id:'SUR',label:'SURINAME'},
      {id:'SJM',label:'SVALBARD AND JAN MAYEN ISLANDS'},
      {id:'SWE',label:'SVEZIA'},
      {id:'CHE',label:'SVIZZERA'},
      {id:'SWZ',label:'SWAZILAND'},
      {id:'TWN',label:'TAIWAN'},
      {id:'TJK',label:'TAJIKISTAN'},
      {id:'TZA',label:'TANZANIA'},
      {id:'IOT',label:'TERRITORIO BRITANNICO DELL\'OCEANO INDIANO'},
      {id:'THA',label:'THAILANDIA'},
      {id:'TLS',label:'TIMOR EST'},
      {id:'TGO',label:'TOGO'},
      {id:'TKL',label:'TOKELAU'},
      {id:'TON',label:'TONGA'},
      {id:'TTO',label:'TRINIDAD AND TOBAGO'},
      {id:'TUN',label:'TUNISIA'},
      {id:'TUR',label:'TURCHIA'},
      {id:'TKM',label:'TURKMENISTAN'},
      {id:'TUV',label:'TUVALU'},
      {id:'UKR',label:'UCRAINA'},
      {id:'UGA',label:'UGANDA'},
      {id:'HUN',label:'UNGHERIA'},
      {id:'URY',label:'URUGUAY'},
      {id:'UZB',label:'UZBEKISTAN'},
      {id:'VUT',label:'VANUATU'},
      {id:'VEN',label:'VENEZUELA'},
      {id:'VNM',label:'VIETNAM'},
      {id:'WLF',label:'WALLIS E FUTUNA'},
      {id:'YEM',label:'YEMEN'},
      {id:'YU ',label:'YUGOSLAVIA'},
      {id:'ZR ',label:'ZAIRE'},
      {id:'ZMB',label:'ZAMBIA'},
      {id:'ZWE',label:'ZIMBABWE'},
      

   
   
   ]
   